<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle
      >Debajo hay una lista de las opciones creadas en otros items del menú.<br />
      <strong>Clonar</strong> crea una copia de dicha opción en el item actual.
      Los cambios en una no se reflejaran en la otra.<br />
      <strong>Usar</strong> agrega la opción al item actual. Ciertos cambios en
      la opción original se veran reflejados en este item.</v-card-subtitle
    >
    <v-card-text>
      <v-skeleton-loader type="paragraph" v-if="!options" />
      <p class="mb-0" v-else-if="!options.length">
        No hay opciones disponibles
      </p>
      <div v-else class="options">
        <div
          class="option d-flex flex-row align-center"
          v-for="option of options"
          :key="option.id"
        >
          <div>
            <div>
              <span class="name">{{ option.title }}</span>
            </div>
            <div>
              <v-chip
                v-if="option.type === OptionType.Add"
                class="mr-1"
                x-small
                label
                >{{ $t('optionEditor.repeatableBadge') }}</v-chip
              >
              <v-chip v-if="option.item" x-small label
                >Creado en {{ option.item.name }}</v-chip
              >
              <v-chip
                x-small
                label
                v-if="option.itemCount > 1"
                color="green"
                dark
                >Usado en {{ option.itemCount }} items</v-chip
              >
            </div>
          </div>
          <v-spacer />
          <div class="actions">
            <v-btn color="info" small rounded depressed @click="use(option)"
              ><v-icon class="mr-1" small>mdi-bullseye</v-icon> Usar</v-btn
            >
            <v-btn
              color="primary"
              class="ml-1"
              small
              rounded
              depressed
              @click="clone(option)"
              ><v-icon class="mr-1" small>mdi-content-copy</v-icon>
              Clonar</v-btn
            >
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { OptionType } from '../../enums/OptionType';
  import { IOption } from '../../interfaces/IOption';
  import { IItem } from '../../interfaces/IItem';
  import OptionsService from '../../api/services/options.service';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { IBranch } from '../../interfaces/IBranch';
  import { vueData } from '../../VueData';
  import { IMenu } from '../../interfaces/IMenu';

  @Component
  export default class OptionsSelector extends Vue {
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;
    @Prop() item: IItem;
    @Prop() menuId: number | null;
    options: IOption[] = null;
    title: string = 'Opciones';
    loading: boolean = false;

    OptionType = OptionType;

    async created() {
      await this.loadOptions();
    }

    async loadOptions() {
      this.options = null;
      try {
        const options = await OptionsService.getAllUsable(
          this.restaurant.id,
          this.branch.id,
          'all',
          this.menuId
        );
        this.options = options.filter((o) => o.itemId !== this.item.id);
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      }
    }

    async clone(option: IOption) {
      this.loading = true;
      try {
        option = await OptionsService.getById(option.id);
        this.$parent.$emit('clone', option);
        this.$emit('close');
      } catch (e) {
        vueData.serverError(e);
      } finally {
        this.loading = false;
      }
    }

    async use(option: IOption) {
      this.loading = true;
      try {
        option = await OptionsService.getById(option.id);
        this.$parent.$emit('use', option);
        this.$emit('close');
      } catch (e) {
        vueData.serverError(e);
      } finally {
        this.loading = false;
      }
    }

    cancel() {
      this.$emit('close');
    }
  }
</script>

<style lang="scss" scoped>
  .options {
    background-color: #fafafa;
    padding: 10px;
    border-radius: 10px;

    .option {
      padding: 5px;

      &:nth-child(odd) {
        background-color: #f2f2f2;
      }
    }
  }
</style>
